import React from 'react';

import './ButtonExit.css';

const ButtonExit = (props) => (
  <button className='button-exit' onClick={props.onClick}>
EXIT
  </button>
);

export default ButtonExit;